import { render, staticRenderFns } from "./eb-number-input.vue?vue&type=template&id=5081fddc&scoped=true&"
import script from "./eb-number-input.vue?vue&type=script&lang=js&"
export * from "./eb-number-input.vue?vue&type=script&lang=js&"
import style0 from "./eb-number-input.vue?vue&type=style&index=0&id=5081fddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5081fddc",
  null
  
)

export default component.exports